import { FunctionComponent } from "react";

import { CompetitorsTable } from "../components/CompetitorsTable";

/** The Competitors tab of Do-not-contact; the page header with the tabs is DoNotContact's. */
export const CompetitorsView: FunctionComponent = () => (
	<div className="w-full">
		<CompetitorsTable />
	</div>
);
